import { render, staticRenderFns } from "./DetailsPanelBridge.vue?vue&type=template&id=83efa0f0&scoped=true"
import script from "./DetailsPanelBridge.vue?vue&type=script&lang=ts"
export * from "./DetailsPanelBridge.vue?vue&type=script&lang=ts"
import style0 from "./DetailsPanelBridge.vue?vue&type=style&index=0&id=83efa0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83efa0f0",
  null
  
)

export default component.exports